import React from "react";
import { Table } from "antd";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const DeletedResultHierarchyDigitalMediaModal = ({
  isDeleteHierarchyResult,
  toggleDeleteHierarchyResult,
  deleteHierarchyListDataResult,
  program,
  history,
}) => {

  const columnsHierarchyResult = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Result',
      dataIndex: 'result',
      key: 'result',
    },
  ];

  return (
    <>
      <Modal
        className={`modal-event-delete-hierarchy-list modal-lg`}
        isOpen={isDeleteHierarchyResult}
        toggle={toggleDeleteHierarchyResult}
        onClosed={() => {
          history.push(`/program/view/${program.id}`);
        }}
      >
        <ModalHeader>
          <div>Media deleted from the following programs</div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Table
            pagination={false}
            rowKey="id"
            columns={columnsHierarchyResult}
            dataSource={deleteHierarchyListDataResult}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeletedResultHierarchyDigitalMediaModal;
